<div class="result" (click)="onResultClicked()">
  <div class="result--icon">
    <img src="../../../../../../../assets/images/icons/{{ resultIconUI }}.svg" />
    <p data-testid="global-search-icon-text">{{ resultTextUI }}</p>
  </div>
  <div class="result--text" data-testid="global-search-result-text">
    @for (text of item.resultTextArray; track text; let i = $index) {
      <div>
        <div
          [ngClass]="{
            'result--text-active': i === 1,
            'result--text-inactive': i !== 1,
          }"
        >
          {{ text }}
        </div>
      </div>
    }
  </div>
</div>
